/**
 * @generated SignedSource<<1d54c19b476cdd7d85bb5d1aeb500b78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxMonthlyBudget",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FundingSourceBudgetWalletUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWalletTPayload",
        "kind": "LinkedField",
        "name": "updateWalletTByWalletId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletT",
            "kind": "LinkedField",
            "name": "walletT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FundingSourceBudgetWalletUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWalletTPayload",
        "kind": "LinkedField",
        "name": "updateWalletTByWalletId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletT",
            "kind": "LinkedField",
            "name": "walletT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60d2c2c11c4182bc82b07c0714ece364",
    "id": null,
    "metadata": {},
    "name": "FundingSourceBudgetWalletUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FundingSourceBudgetWalletUpdateMutation(\n  $input: UpdateWalletTByWalletIdInput!\n) {\n  updateWalletTByWalletId(input: $input) {\n    walletT {\n      walletId\n      maxMonthlyBudget\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8a00d288185ce6631f7bbade5518c83b";

module.exports = node;
